import { NavLink } from 'react-router-dom';
import { events, leagues, sports } from '../../data/fixtures';
import type { IconName } from '../Icon';
import { Icon } from '../Icon';

const sportIcons: Record<string, IconName> = {
  football: 'football', cricket: 'cricket', tennis: 'tennis', basketball: 'basketball',
  'ice-hockey': 'hockey', volleyball: 'volleyball', 'table-tennis': 'table-tennis', esports: 'esports',
};

export function LeftSidebar() {
  return (
    <aside className="left-sidebar" aria-label="Sports menu">
      <section className="sidebar-panel">
        <header className="sidebar-panel__header"><Icon name="star" /><span>Top leagues</span><Icon name="chevron" /></header>
        <div className="sidebar-panel__body">
          {leagues.slice(0, 4).map((league) => (
            <a href={`#league-${league.id}`} className="sidebar-league" key={league.id}>
              <span className="sidebar-league__mark">{league.country.code.slice(0, 2)}</span>
              <span className="sidebar-league__name">{league.name}</span>
              <span>{events.filter((event) => event.leagueId === league.id).length}</span>
            </a>
          ))}
        </div>
      </section>

      <NavLink to="/live" className="live-link"><Icon name="live" /><span>Live events</span><strong>{events.filter((event) => event.isLive).length}</strong></NavLink>

      <label className="sidebar-search">
        <span className="sr-only">Search events</span>
        <input type="search" placeholder="Search" />
        <Icon name="search" />
      </label>

      <section className="sidebar-panel sidebar-panel--sports">
        <header className="sidebar-panel__header"><Icon name="football" /><span>Sports</span><Icon name="chevron" /></header>
        <div className="sidebar-panel__body">
          {sports.map((sport) => (
            <NavLink to={sport.id === 'cricket' ? '/cricket' : sport.id === 'esports' ? '/esports' : `/sports?type=${sport.id}`} className="sidebar-sport" key={sport.id}>
              <Icon name={sportIcons[sport.id]} />
              <span>{sport.name}</span>
              <span>{sport.eventCount}</span>
            </NavLink>
          ))}
        </div>
      </section>
    </aside>
  );
}
